module.exports = __webpack_public_path__ + "static/assets/7efe6c760528470b8574e5536b205d20.png";